import { match } from 'ts-pattern';
import { Creator } from '~/clientApi/creator.model';
import { useFetchCreatorPublic } from '~/hooks/api/media-kits/useFetchCreatorPublic';

import { CreatorProfileCardBuilder } from './CreatorProfileCardBuilder';
import { ProfileCardSkeleton } from './ProfileCardSkeleton';

export interface TalentProfileProperties {
  creatorId: string;
  creator: Creator;
}

export const TalentProfile = ({
  creatorId,
  mediaKitId,
}: {
  creatorId: TalentProfileProperties['creatorId'];
  mediaKitId: string;
}) => {
  const creator = useFetchCreatorPublic(creatorId);

  return match(creator.status)
    .with('loading', () => <ProfileCardSkeleton />)
    .with('error', () => <p>Error</p>)
    .with('success', () => (
      <CreatorProfileCardBuilder
        mediaKitId={mediaKitId}
        creator={creator.data}
      />
    ))
    .exhaustive();
};
